/* unplugin-vue-components disabled */import { render } from "./FormRangeDate.vue?vue&type=template&id=71b4f0ae&ts=true"
import script from "./FormRangeDate.vue?vue&type=script&lang=ts"
export * from "./FormRangeDate.vue?vue&type=script&lang=ts"

import "./FormRangeDate.vue?vue&type=style&index=0&id=71b4f0ae&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__